import { HTML_LANG, pathFor } from '@nexa/content';
import { jsonld } from '@nexa/seo';
import { ORGANIZATION, SITE } from '@/core/config/site.ts';
import { useCopy, useLocale } from '@/core/i18n';
import { PageMeta } from '@/core/seo';
import { AiAgentsSection } from '@/features/ai-agents';
import { CollabSection } from '@/features/collab';
import { ConnectorsSection } from '@/features/connectors';
import { CtaSection } from '@/features/cta';
import { DownloadSection } from '@/features/download';
import { FaqSection } from '@/features/faq';
import { HeroSection } from '@/features/hero';
import { KnowledgeSection } from '@/features/knowledge';
import { ModulesSection } from '@/features/modules';
import { PricingSection } from '@/features/pricing';
import { ProjectMgmtSection } from '@/features/project-mgmt';
import { SecuritySection } from '@/features/security';
import { SocialProofSection } from '@/features/social-proof';

/**
 * Trang chủ. Là trang DUY NHẤT khai `Organization` + `WebSite` trong JSON-LD: hai schema đó nói
 * về CẢ SITE, khai lại ở mọi trang chỉ làm nhiễu và không thêm điểm nào.
 */
export default function HomePage() {
  const locale = useLocale();
  const copy = useCopy();

  return (
    <>
      <PageMeta
        pageId="home"
        jsonLd={[
          jsonld.organization(SITE, {
            logo: ORGANIZATION.logo,
            legalName: ORGANIZATION.legalName,
            email: ORGANIZATION.email,
          }),
          jsonld.webSite(SITE, HTML_LANG[locale], pathFor('home', locale)),
          jsonld.faqPage(copy.faq.items),
        ]}
      />
      {/*
        Thứ tự này là THỨ TỰ THIẾT KẾ (`template.html`: #top 605 · social-proof 776 · #modules 788
        · #collab 812 · #pm 837 · #ai 895 · #knowledge 947 · #connectors 974 · #security 994 ·
        #pricing 1012 · #faq 1027 · #cta 1041), và nó phải khớp thứ tự khai trong `SPY_IDS` của
        `Header`. `useScrollSpy` lấy phần tử đầu theo thứ tự khai, nên đảo `#modules` với `#collab`
        làm nav NHẢY NGƯỢC khi cuộn — im lặng, không test nào bắt được vì jsdom không có
        `IntersectionObserver` thật.

        Bốn section cuối land ở lô D và chúng ĐÓNG NỢ D-A′-1: `SPY_IDS` khai đủ 8 id từ lô A′
        nhưng `#security` `#pricing` `#faq` chưa tồn tại, nên ba mục nav cuối bấm không đi đâu.
        `#cta` cũng là đích của nút trong `Header`, `MobileDrawer` và cả hai nút hero.

        `#download` KHÔNG có trong bản thiết kế: user chốt 2026-09-28 thêm nó giữa `#faq` và
        `#cta`. Nó cố ý KHÔNG vào `SPY_IDS` của `Header` — nav đã chật 6 mục, và lối tới section này
        là cột "Ứng dụng" ở footer.
      */}
      <HeroSection />
      <SocialProofSection />
      <ModulesSection />
      <CollabSection />
      <ProjectMgmtSection />
      <AiAgentsSection />
      <KnowledgeSection />
      <ConnectorsSection />
      <SecuritySection />
      <PricingSection />
      <FaqSection />
      <DownloadSection />
      <CtaSection />
    </>
  );
}
